<template>
    <section class="dashboard">
        <header class="dash-header">
            <h1 class="dash-title">Panel główny</h1>

            <div class="range-filter">
                <label for="range">Zakres:</label>
                <select id="range" v-model="selectedRange">
                    <option v-for="opt in rangeOptions" :key="opt.value" :value="opt.value">
                        {{ opt.label }}
                    </option>
                </select>
            </div>
        </header>

        <DashboardKpi :selected-range="selectedRange" />

        <DashboardCharts :selected-range="selectedRange" :theme-color="themeColor" :theme-accent="themeAccent" />

        <DashboardLastOrders />
    </section>
</template>

<script>
import DashboardKpi from '../dashboard-elements/DashboardKpi.vue'
import DashboardCharts from '../dashboard-elements/DashboardCharts.vue'
import DashboardLastOrders from '../dashboard-elements/DashboardLastOrders.vue'

export default {
    components: { DashboardKpi, DashboardCharts, DashboardLastOrders },
    data() {
        return {
            selectedRange: '30d',
            rangeOptions: [
                { value: '7d', label: '7 dni' },
                { value: '30d', label: '30 dni' },
                { value: '90d', label: '90 dni' },
                { value: '180d', label: '180 dni' },
                { value: 'ytd', label: 'Bieżący rok' },
                { value: '1y', label: 'Ostatni rok' },
                { value: 'all', label: 'Wszystko' },
            ],
            themeColor: '#899c5f',
            themeAccent: '#899c5f',
        }
    }
}
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.dashboard {
  max-width: 1200px;
  margin: 0 auto;
  cursor: default;
}

.dash-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;

  @media (max-width: 640px) {
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
  }
}

.dash-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: $color-primary-dark;
  margin: 0;
}

.range-filter {
  display: flex;
  align-items: center;
  gap: 0.5rem;

  label {
    font-weight: 600;
    color: $color-text;
    white-space: nowrap;
  }

  select {
    font-family: 'Inter', sans-serif;
    padding: 8px 10px;
    border: 2px solid $color-grey;
    border-radius: 8px;
    font-size: 0.95rem;
    background: $color-white;

    &:focus {
      border-color: $color-primary;
      outline: none;
    }
  }

  @media (max-width: 640px) {
    width: 100%;
    flex-wrap: wrap;

    select {
      flex: 1;
      width: 100%;
    }
  }
}
</style>